import axios from 'axios';

const DNAME = process.env.REACT_APP_DNAME;

// A shared Axios instance for all ADMIN (protected) API calls.
// It automatically attaches the JWT token from localStorage to every request.
const axiosInstance = axios.create({
    baseURL: DNAME,
});

// Request interceptor — attach Bearer token before every request
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor — if token expired/invalid, force logout
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // Token is invalid or expired — clear storage and redirect to login
            localStorage.removeItem('token');
            localStorage.removeItem('loggedIn');
            window.location.href = '/admin';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
